import callAPiBase from './base';

const boletoApi = {
  getUrl: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/boletoUrlGet',
      method: 'GET',
      useToken: true,
      title: 'Boleto - Get URL',
      params,
    }),
};

export { boletoApi };
export default boletoApi;
